// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 86) return "static/chunks/86.23562807cb9c6312.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 730 ? "44530001" : chunkId) + "-" + {"230":"a5f0245ebc5969e2","730":"d9a7c8cc96736e7f"}[chunkId] + ".js";
};